class ReactivationProductForm extends HTMLElement { 
  constructor() {
    super();

    this.discountCode = this.dataset.discountCode;
    this.giftDiscountCode = this.dataset.giftDiscountCode;
    this.mainProductVariant = JSON.parse(this.dataset.mainProductVariant);
    this.secondProductVariant = JSON.parse(this.dataset.secondProductVariant);
    this.nextProductVariant = JSON.parse(this.dataset.nextProductVariant);
    this.sellingPlanId = this.mainProductVariant.selling_plan_allocations[0].selling_plan_id;
    
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.proceedToCheckout.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');

    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  async proceedToCheckout(event) {
    event.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');

    const signupConfig = {
      mainProduct: {
        variantId: this.mainProductVariant.id,
        sellingPlanId: this.sellingPlanId,
      },
      addonProduct: {
        variantId: this.secondProductVariant?.id,
      },
      nextProduct: {
        variantId: this.nextProductVariant?.id,
      },
      discountCode: this.discountCode,
      ...(this.giftDiscountCode ? { addonDiscountCode: this.giftDiscountCode } : {}),
    };

    try {
      const subscriptionCart = new SubscriptionCart();
      await subscriptionCart.checkout(signupConfig, true);
    } catch (error) {
      console.error('Checkout error:', error);
      this.dispatchError('Failed to proceed to checkout');
    } finally {
      this.submitButton.classList.remove('loading');
      this.querySelector('.loading__spinner').classList.add('hidden');
    }
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

if (!customElements.get('reac-product-form')) {
  customElements.define(
    'reac-product-form', ReactivationProductForm
  );
}
